module.exports = __webpack_public_path__ + "fonts/proximanova-bold-webfont.ttf";